export const DEFAULT_REPLENISHMENT_NOTES = 'Marked as restocked';

function normalizeNotesInput(value: unknown): string {
  if (typeof value !== 'string') return '';
  return value.trim();
}

export function shouldShowNotesInTable(
  notes: unknown,
  defaultNotes = DEFAULT_REPLENISHMENT_NOTES,
): boolean {
  const normalized = normalizeNotesInput(notes);
  if (!normalized) return false;
  return normalized !== defaultNotes;
}

export function getNotesPreview(
  notes: unknown,
  maxLength = 60,
): { shouldShow: boolean; preview: string; full: string } {
  const full = normalizeNotesInput(notes);
  const shouldShow = shouldShowNotesInTable(full);
  if (!shouldShow) return { shouldShow: false, preview: '', full: '' };

  if (full.length <= maxLength)
    return { shouldShow: true, preview: full, full };

  const trimmed = full.slice(0, maxLength).trimEnd();
  return {
    shouldShow: true,
    preview: `${trimmed}...`,
    full,
  };
}
